<template>
  <div class="container">
    <!--    <PageLoader/>-->
    <!--    <splash-loader />-->
    <modal-container />
    <drawer />

    <div class="container__wrapper container__wrapper--topbar-adjust">
      <topbar>
        <div class="topbar__panel">
          <div class="topbar__heading">
            <h1>Dashboard</h1>
          </div>
        </div>
      </topbar>

      <sidebar />

      <div class="content">
        <div class="content__wrapper">
          <page-loader v-if="false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Topbar from '@components/Topbar'
import Sidebar from '@components/Sidebar'
import ModalContainer from '@components/modals/ModalContainer'
import Drawer from '@components/drawers/Drawer'
import PageLoader from '@components/shared/PageLoader'

export default {
  metaInfo: { title: 'Dashboard' },
  components: {
    ModalContainer,
    Drawer,
    Topbar,
    Sidebar,
    PageLoader,
  },
}
</script>
